import RoutesConfig from '../config/route/RoutesConfig';

interface IRedirectNotification {
  notification: any;
  history: any;
}

export const modules = RoutesConfig?.privateRoutes[0]?.subRoutes?.map(
  (value: any): any => value.path,
);

const RedirectNotification = (props: IRedirectNotification): null => {
  props.history.push(
    `/${
      props.notification.message.tags.filter((value: any): any =>
        modules?.includes(value),
      )[0]
    }`,
  );
  return null;
};

export default RedirectNotification;
